
import * as d3 from 'd3'

export default {

  data: () => ({
    pop             : {
      width: 1100,
      height: 700,
      x: 0,
      y: 0,
      bar: 32,
      moveX: 0,
      moveY: 0,
      deltaX: 0,
      deltaY: 0,
    },
  }),


  methods: {

    draw_Popup_Window(data_) {

      this.canvas_Popup = this.svg
      .append('svg')
      .attr('width', 1100).attr('height', 700)

      .append('g')
      .attr('id', `POPUP`)
      .attr('transform', `translate(0.5, 0.5)`)
      .attr('font-family', 'roboto')
      .attr('opacity', 0).attr('visibility', 'hidden')

      // Background - Close
      this.canvas_Popup
      .append('rect')
      .attr('x', -.5).attr('y', -.5).attr('width', this.Canvas.CanvasWidth)
      .attr('height', this.Canvas.CanvasHeight).attr('fill', '#000').attr('opacity', .7)
      .on('click', () => {
        this.close_Popup()
      }) 

      let p = this.pop
      let scrollY = (window.scrollY) + p.y
      let this_ = this
     
      let modal = this.canvas_Popup
      .append('g')
      .attr('id', 'MODAL_POPUP')
      .attr('transform', `translate(${this.pop.moveX},${this.pop.moveY})`)
      .call(
        d3.drag()
        .on('start', function() {
          if (d3.event.y >= p.y + p.moveY && d3.event.y <=  p.y + p.moveY + p.bar) {
            let coordinate = this_.getCoordinates(d3.select(this))
            p.deltaX = coordinate[0] - d3.event.x
            p.deltaY = coordinate[1] - d3.event.y
          } else return
        })
        .on('drag', function() {
          if (d3.event.y >= p.y + p.moveY && d3.event.y <=  p.y + p.moveY + p.bar) {
            p.moveX = d3.event.x + p.deltaX
            p.moveY = d3.event.y + p.deltaY

            p.moveX = Math.max(-p.x, Math.min(this_.Canvas.CanvasWidth - p.width - p.x, p.moveX))
            p.moveY = Math.max(-p.y, Math.min(this_.Canvas.CanvasHeight - p.height - p.y, p.moveY))
            
            modal.attr('transform', `translate(${p.moveX},${p.moveY})`)
          } else return
        })
      )

      // Filter Window
      modal
      .append('rect')
      .attr('x', p.x).attr('y', scrollY)
      .attr('width', p.width).attr('height', p.height) .attr('rx', 2).attr('stroke', '#757575').attr('stroke-width', 1)
      .attr('fill', '#fff').attr('filter', 'url(#dropshadow)').attr('opacity', .5)

      // Window bar
      modal
      .append('rect')
      .attr('id', 'asdasd')
      .attr('x', p.x).attr('y', scrollY).attr('width', p.width).attr('height', p.bar)
      .attr('fill', 'url(#windowBar)')

      // Contents Window 
      modal
      .append('rect')
      .attr('x', p.x).attr('y', scrollY + p.bar).attr('width', p.width).attr('height', p.height - p.bar)
      .attr('fill', 'url(#contentWindow)')

      modal
      .append('line')
      .attr('x1', p.x).attr('x2', p.x + p.width)
      .attr('y1', scrollY + p.bar + 1).attr('y2', scrollY + p.bar + 1)
      .attr('stroke', '#bcbcbc').attr('stroke-width', 0.5)

      modal
      .append('line')
      .attr('x1', p.x).attr('x2', p.x + p.width)
      .attr('y1', scrollY + p.bar + 2).attr('y2',scrollY + p.bar + 2)
      .attr('stroke', '#fff').attr('stroke-width', 1)

      this.canvas_Popup.transition().duration(500)
      .attr('visibility', 'display').attr('opacity', 1)

      this.draw_Popup_Elements(modal, data_)
    },



    draw_Popup_Elements(selection, data_) {
      console.log(data_) /////
      let scrollY = (window.scrollY) + this.pop.y

      // Close Button
      let close = selection
      .append('g')
      .attr('id', 'CLOSE')
      .attr('transform', `translate(${this.pop.x+this.pop.width-25}, ${scrollY +8})`)
      .attr('font-family', 'roboto')
      .style('cursor', 'pointer')
      .on('mouseover', () => {
        d3.select('#CLOSE').style('opacity', .3)
      })
      .on('mouseout', () => {
        d3.select('#CLOSE').style('opacity', 1)
      })
      .on('click', () => {
        this.close_Popup()
      }) 

      close
      .append('rect')
      .attr('x', 0).attr('t', 0)
      .attr('width', 15).attr('height', 15)
      .attr('fill', '#fff')
      .attr('stroke', '#bcbcbc').attr('stroke-width', .5)

      close
      .append('path')
      .attr('transform', `translate(0, 0) scale(.03)`)
      .attr('fill', '#333')
      .attr('d', `M289.94,256l95-95A24,24,0,0,0,351,127l-95,95-95-95A24,24,0,0,0,127,161l95,95-95,95A24,24,0,1,0,161,385l95-95,95,95A24,24,0,0,0,385,351Z`)
      
      // KEYPLAN
      this.loadSvg(
        selection, {
        x   : this.pop.x,
        y   : scrollY,
        url : `/Visualization/includes/Network_Legneds.svg`
      }).then(() => {
        d3.selectAll("text").style('font-family', 'roboto')
      })
      
      let except = [
        {area: 'TOPSIDE', zone:'North',    erec: 'ND110'},
        {area: 'TOPSIDE', zone:'Central',  erec: 'CD110'},
        {area: 'TOPSIDE', zone:'South',    erec: 'SD110'},
        // {area: 'TOPSIDE', zone:'Flare',    erec: 'NF110'},
        {area: 'LQ',      zone:'LQ',       erec: 'LD110'},
        // {area: 'LQ',      zone:'Heli',     erec: 'LH110'},
        // {area: 'LQ',      zone:'House',    erec: 'LV510'},
      ]
      let dataSet = null
      let findZone = except.find(f=> f.zone == data_.BLK)
      
      // Load SVG file
      let setUrl = ``

      if (data_.AREA == 'Hull') setUrl = `Hull/${data_.BLK}`; else setUrl = `Topside/${data_.AREA}/${data_.BLK}`
      if (data_.ZONE != '') setUrl = `Topside/${data_.ZONE}/${data_.ZONE.toUpperCase()}`
      console.log(`/Visualization/BlockDivision/Rev1/${setUrl}.svg`) /////

      this.loadSvg(
        selection, {
        x   : this.pop.x + 100,
        y   : scrollY + this.pop.bar + 50,
        url : `/Visualization/BlockDivision/Rev1/${setUrl}.svg`
      }).then(() => {
        d3.selectAll("text").style('font-family', 'roboto')
        d3.select(`#BLOCK-GROUP`).attr('transform', `translate(0, 0) scale(.85)`)

        if(findZone) {
          this.func_blockColoring(selection, findZone.area, 'EREC', findZone.erec)// -----> vFunction/block_Coloring.js
          console.log('EREC', findZone.area, findZone.erec)
        } else {
          this.func_blockColoring(selection, 'NA', 'ASSEMBLY', data_.BLK)// -----> vFunction/block_Coloring.js
          console.log('ASSEMBLY', data_.BLK)
        }
      })

      selection
      .append('text')
      .attr('transform', `translate(${this.pop.x + 10}, ${scrollY + 20})`)
      .attr('font-size', 13).attr('fill', '#000')
      .text(`Assembly Sequence`)

      selection
      .append('text')
      .attr('transform', `translate(${this.pop.x + 10}, ${scrollY + 55})`)
      .attr('font-size', 16).attr('fill', '#44A9DF')
      .text(data_.BLK)

      selection
      .append('text')
      .attr('transform', `translate(${this.pop.x + 10}, ${scrollY + 70})`)
      .attr('font-size', 11).attr('fill', '#333')
      .text(data_.TITLE)

      

      if(findZone) {
        dataSet = this.masterList.filter(f=> f.G_EREC == findZone.erec)
        if(data_.BLK == 'LQ') dataSet = this.masterList.filter(f=> f.AREA == 'LQ' && f.BLK != 'LV511' && f.BLK != 'LH111')
      } else {
        dataSet = this.masterList.filter(f=> f.G_EREC == data_.BLK)
      }

      this.func_stageBarChart( // -----> ### vFunction/stage_BarChart.js
        selection, 
        dataSet, 
        {
          id: 'OVERALL',
          x: this.pop.x + 10,       y: scrollY + 105,     nameLen: 100,
          tSize: 9,     lineH: 18,
          barLen: 120,  barH: 12,
        },
      )
    },


    close_Popup() {
      this.canvas_Popup.transition().duration(500).attr('opacity', 0)
      this.canvas_Popup.transition().duration(500).delay(500).attr('visibility', 'hidden')

      setTimeout(() => { 
        this.canvas_Popup.remove()
      }, 500)

      this.reset_PDF_Data()
    },


  }
}